import { Stack } from '@mui/material';
import { PasswordForm } from './components/PasswordForm';

export const Form = () => {

    return (
        <Stack width='100%' justifyContent='center' direction='row'>
                
            <PasswordForm />
            
        </Stack>
    )
}
